<template>
  <div class="fragment">
    <div class="section-label"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['ordersInbound_comments'])"></div>
      {{ $t('ordersInbound_comments.localization_value.value') }}
      <!--      Comment-->
    </div>
    <div class="order-create__row custom-row">
      <div class="order-create__col custom-col custom-col--66 custom-col--md-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_widthCm'])"></div>
        <TextareaDefault
            :label="$t('common_comment.localization_value.value')"
            v-bind:class="{'ui-no-valid': ordersInbound.validation.comment}"
            :error="ordersInbound.validation.comment"
            :errorTxt="$t(`${ordersInbound.validationTranslate.comment}.localization_value.value`)"
            v-model="ordersInbound.data.comment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TextareaDefault from "../../../../../../UI/textarea/TextareaDefault/TextareaDefault";

export default {
  name: "CommentsBlock",
  components: {
    TextareaDefault,
  },
  props: {
    ordersInbound: Object,
  },
}
</script>

<style scoped>

</style>
